require('./tab-list.scss');

require('./tab.tag');

riot.tag2('tab-list', '<div class="tab-list-content"> <yield></yield> </div>', '', '', function(opts) {
});
